import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ActivateSmartLockResData } from "./ActivateSmartLockResData";

const ENDPOINT = "/otc/smartlock/activate";

export class ActivateSmartLockCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: ActivateSmartLockReqData;

    constructor(installationName: string, serialNumber: string, smartLockMode: number, sessionDuration: number, codeValidity: number) {
        super();
        this.payload = new ActivateSmartLockReqData(installationName, serialNumber, smartLockMode, sessionDuration, codeValidity);
    }

    public async execute(): Promise<ActivateSmartLockResData> {
        let res = await this.executeCommand(this.payload);
        return new ActivateSmartLockResData(res);
    }
}

export class ActivateSmartLockReqData {
    installationName: string;
    serialNumber: string;
    smartLockMode: number;
    sessionDuration: number;
    codeValidity: number;

    constructor(installationName: string, serialNumber: string, smartLockMode: number, sessionDuration: number, codeValidity: number) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.smartLockMode = smartLockMode;
        this.sessionDuration = sessionDuration;
        this.codeValidity = codeValidity;
    }
}
